import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect
  , Inject, OnDestroy, OnInit
} from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { RouterOutlet } from '@angular/router';
import { FuseAlertComponent } from '@fuse/components/alert';
import { ItmToolbarComponent } from '@itm/components/toolbar';
import { 
  GridModule
} from '@syncfusion/ej2-angular-grids';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PdfViewerModule } from '@syncfusion/ej2-angular-pdfviewer';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'document-viewer-modal',
    templateUrl: './document-viewer-modal.component.html',
    styleUrls: ['./document-viewer-modal.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      // RouterOutlet
      CommonModule
      , GridModule
      // , ItmToolbarComponent
      // , FuseAlertComponent
      , PdfViewerModule
      , MatInputModule],
    providers: [
    ],
})
export class DocumentViewerModalComponent implements OnInit, OnDestroy {
  fileUrl: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private sanitizer: DomSanitizer
    , private dialogRef: MatDialogRef<DocumentViewerModalComponent>) {
      
    this.fileUrl = data.fileUrl;
    console.log(data)
    effect(() => {
    })
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  checkFile(url: string): boolean {
    // console.log(url)
    // console.log((/\.(pdf|png|jpg|jpeg|gif|bmp)$/i.test(url)))
    return /\.(pdf|png|jpg|jpeg|gif|bmp)$/i.test(url);
  }

  getSafeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  close(): void {
    this.dialogRef.close();
  }
}
